module.exports = __webpack_public_path__ + "static/media/InterestedPrograms.4375ca58.svg";